import axios from "axios";

export const GET_ALL = "medical_network";


export let getMedicalNetworkAll = function (status) {
  return axios.get(`${GET_ALL}`);
}
